<template>
  <l-modal
    :title="t('ordering.move-products-modal-title')"
    size="small"
    :button-text="t('ctas.confirm')"
    @action="$emit('confirm')"
    @close="$emit('close')"
  >
    {{
      t('ordering.change-product', {
        from: fromTab.name ?? fromTab.tableName,
        to: toTab?.name ?? toTab?.tableName ?? toTable.name
      })
    }}

    <div v-for="product in products" :key="product.id" class="flex flex-col mt-6">
      <product-component :product="product" :show-price="false" :disable-swipe="true" />
    </div>
  </l-modal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import { LModal } from '@last/core-ui/paprika'

import ProductComponent from '@/components/Product.vue'
import type { Tab, Table, TabProduct } from '@/types'

withDefaults(
  defineProps<{
    fromTab: Tab
    toTable: Table
    toTab: Tab | null
    products: TabProduct[]
  }>(),
  {
    toTab: null
  }
)

defineEmits<{
  close: []
  confirm: []
}>()

const { t } = useI18n()
</script>
